import { SpellMap } from 'web/data/models'
import { SPELL_ID } from '../ids/spell-id'
import { TALENT_ID } from '../ids/talent-id'
import { MODIFIER_ID } from '../ids/modifier-id'
import { DRUID_TALENTS } from '../talents/druid'
import { copyTalentPropsToSpell } from 'web/data/core-data'

export const DRUID_SPELLS: SpellMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Resto Druid
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.DRUID.RESTO.TRANQ]: {
        id: SPELL_ID.DRUID.RESTO.TRANQ,
        talentId: undefined,

        name: "Tranquility",
        shortName: "Tranq",

        cooldown: 180,
        affectedByModifierIds: [MODIFIER_ID.ESSENCE_VOP],

        game_id: 740,
        icon_name: "spell_nature_tranquility",
    },

    [SPELL_ID.DRUID.RESTO.TREE]: {
        id: SPELL_ID.DRUID.RESTO.TREE,
        cooldown: 180,
        affectedByModifierIds: [],

        ...copyTalentPropsToSpell(DRUID_TALENTS[TALENT_ID.DRUID.RESTO.TREE])
    },

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Guardian Druid
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.DRUID.GUARD.STAMP_ROAR]: {
        id: SPELL_ID.DRUID.GUARD.STAMP_ROAR,
        talentId: undefined,

        name: "Stampeding Roar",
        shortName: "Roar",

        cooldown: 60,
        affectedByModifierIds: [],

        game_id: 106898,
        icon_name: "spell_druid_stampedingroar_cat",
    },

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Feral Druid
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.DRUID.FERAL.STAMP_ROAR]: {
        id: SPELL_ID.DRUID.FERAL.STAMP_ROAR,
        talentId: undefined,

        name: "Stampeding Roar",
        shortName: "Roar",

        cooldown: 120,
        affectedByModifierIds: [],

        game_id: 106898,
        icon_name: "spell_druid_stampedingroar_cat",
    },

}
